import React, { useContext, useEffect, useState } from "react";
import ErrorField from "../Components/ErrorField";
import { IsEmailValid, isStringEmpty } from "../Helpers/Utilities";
import { ForgotPassword, UserLoginMessage } from "../Helpers/HelperText";
import { UserLoginService } from "../WebApiServices/UserLogin.service";
import { HTTPResponse, ToastMessageType } from "../Helpers/Enums";
import { AppContext } from "../Contexts/AppContextProvider";
import { useNavigate } from "react-router-dom";

const PasswordRecovery = () => {

  const iconStyle = {
    width: 45,
    cursor: "pointer",
  };
  const [email, setEmail] = useState("");
  const [emailErr, setEmailErr] = useState("");
  const { ShowToast, ToggleLoader } = useContext(AppContext);
  const navigate = useNavigate();
  const [cooldown, setCooldown] = useState(null);


  useEffect(() => {
    if (cooldown > 0) {
      const timer = setTimeout(() => setCooldown(cooldown - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [cooldown]);


  const HandleEmailChange = (e) => {
    setEmail(e.target.value);
    setEmailErr("");
  };

  const Validate = () => {
    let isValid = true;
    if (isStringEmpty(email)) {
      setEmailErr(UserLoginMessage.LoginEmailBlank);
      isValid = false;
    } else {
      if (!IsEmailValid(email)) {
        setEmailErr(UserLoginMessage.LoginInvalidEmail);
        isValid = false;
        ToggleLoader(false);
      }
    }
    return isValid;
  };
    const HandleReset = async () => {
    
        if (email !== "" && (cooldown === 0 || cooldown === null)) {
            ToggleLoader(true);
        }
   // ToggleLoader(true);
    if (Validate()) { 
      const response = await UserLoginService.ForgotPassword(email);
      const { status } = response;
      switch (status) {
        case HTTPResponse.OK: {
          setEmail("");
          ShowToast(ForgotPassword.EmailSuccess, ToastMessageType.Success);
          break;
        }
        case HTTPResponse.BadRequest: {
          ShowToast(ForgotPassword.EmailNotExistent, ToastMessageType.Failed);
          ToggleLoader(false);
          break;
        }
        case 429: {
          ToggleLoader(false);
          setCooldown(60);
          return; 
        }
        default: {
          ShowToast(ForgotPassword.ErrorOccurred, ToastMessageType.Failed);
          break;
        }
      }

      ToggleLoader(false);
    }
  };


  const handleKeyDown = async (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      await HandleReset(event);
    }
  };

  useEffect(() => {
    // Add event listener for the 'Enter' key when the component mounts
    document.addEventListener("keydown", handleKeyDown);

    // Clean up the event listener when the component unmounts
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [email]);
  return (
    <div className="gradient-custom admin-login">
      <div className="container py-5 custom-container">
        <div className="row justify-content-center align-items-center h-100">
          <div className="col-12 col-md-8 col-lg-6 col-xl-5">
            <div
              className="card bg-white text-black"
              style={{ borderRadius: "1rem", minHeight: 100 }}
            >
              <div className="card-body p-4">
                <div className="mb-md-2 mt-md-2 pb-2">
                  {/* <h3 className="fw-bold mb-4 text-uppercase text-center forgot-password-heading">
                    Forgot Password?
                  </h3> */}
                  {/* ST: 13/10/2024: Added back button */}
                  <h3 className="fw-bold mb-4 text-uppercase text-center forgot-password-heading">
                    <div className="row align-items-center mb-3">
                        <img className="col-md-2 col-lg-2"
                            src="../Assets/images/back-icon.png"
                            alt="Back"
                            style={iconStyle}
                            onClick={() => { navigate("/") }}
                            title="Back"
                        />
                        <span className="col-md-10 col-lg-10">Forgot Password?</span>                        
                    </div>
                  </h3>
                  <div className="form-outline form-white margin-bottom-36">
                    <input
                      type="email"
                      id="typeEmailX"
                      placeholder="Enter Email ID"
                      className="form-control form-control-lg placeholder-font-size"
                      value={email}
                      onChange={HandleEmailChange}
                    />
                    <ErrorField show={emailErr} message={emailErr} style={{paddingLeft: "-25px"}}/>
                  </div>
                  {cooldown > 0 && (
                    <p className="text-center text-danger">
                      Please wait {cooldown} seconds before trying again.
                    </p>
                  )}
                  <div className="text-center mb-2">
                    <center>
                      <button
                        className="btn btn-outline-light btn-lg px-5 login-button"
                        type="submit"
                        onClick={HandleReset}
                        disabled={cooldown > 0}
                      >
                        Reset
                      </button>{" "}
                    </center>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PasswordRecovery;
